import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-38014054")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_c_img_view = _resolveComponent("c-img-view")
  const _component_el_dialog = _resolveComponent("el-dialog")

  return (_openBlock(), _createBlock(_component_el_dialog, {
    title: _ctx.titlename,
    modelValue: _ctx.visible,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.visible = $event)),
    width: "1000px",
    "before-close": _ctx.onCancel
  }, {
    default: _withId(() => [
      _createVNode(_component_c_img_view, { images: _ctx.srcList }, {
        default: _withId(() => [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.srcList, (item, index) => {
            return (_openBlock(), _createBlock("img", {
              src: item,
              key: index,
              width: "200",
              style: {"margin-right":"10px"}
            }, null, 8, ["src"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["images"])
    ]),
    _: 1
  }, 8, ["title", "modelValue", "before-close"]))
})